const action = {
    sign_in: 'Anmelden',
    continue: 'Weiter',
    continue_as: 'Weiter als {{name}}',
    create_account: 'Konto erstellen',
    create_account_without_linking: 'Stattdessen ein neues erstellen',
    create: 'Erstellen',
    enter_passcode: 'Bestätigungscode eingeben',
    confirm: 'Bestätigen',
    cancel: 'Abbrechen',
    save_password: 'Passwort speichern',
    bind: 'Mit {{address}} verknüpfen',
    bind_and_continue: 'Verknüpfen und weiter',
    back: 'Gehe zurück',
    nav_back: 'Zurück',
    nav_skip: 'Überspringen',
    agree: 'Zustimmen',
    got_it: 'Alles klar',
    sign_in_with: 'Mit {{name}} anmelden',
    forgot_password: 'Passwort vergessen?',
    switch_to: 'Zu {{method}} wechseln',
    sign_in_via_passcode: 'Mit Bestätigungscode anmelden',
    sign_in_via_password: 'Mit Passwort anmelden',
    sign_in_via_passkey: 'Mit Passkey anmelden',
    change: '{{method}} ändern',
    link_another_email: 'Andere Email verknüpfen',
    link_another_phone: 'Andere Telefonnummer verknüpfen',
    link_another_email_or_phone: 'Andere Email oder Telefonnummer verknüpfen',
    show_password: 'Passwort anzeigen',
    copy: 'Kopieren',
    verify_via_passkey: 'Überprüfen über Passkey',
    download: 'Herunterladen',
    remove: 'Entfernen',
    edit: 'Bearbeiten',
    save: 'Speichern',
    single_sign_on: 'Single Sign-On',
    authorize: 'Autorisieren',
    use_another_account: 'Anderes Konto verwenden',
    back_to_current_account: 'Zurück zum aktuellen Konto',
    done: 'Fertig',
};
export default Object.freeze(action);
